import { ServiceResourceRule } from 'src/models/appointment/_types';
import { MaxVisitDay } from 'src/models/scheduled-appointment/_types';
import { Identifier } from 'src/types/utilityTypes';

export interface EditEventFormValues {
  // General settings
  serviceId: Identifier | null;
  locationId: Identifier | null;
  startTime: Date;
  endTime: Date;
  /** Per-session cap (appointment.max_visits) */
  maxVisits: number | null;
  /** Series default cap for future sessions (scheduled_appointment.max_visits) */
  seriesMaxVisits: number | null;
  maxVisitDays: MaxVisitDay[];
  description: string;
  notes: string;

  // Staff settings
  primaryTrainerIds: Identifier[];
  secondaryTrainerIds: Identifier[];
  noTrainers: boolean;

  // Recurring settings
  isRecurring: boolean;
  recurringType: 'day' | 'week' | 'month' | 'month_on_date' | 'month_on_day';
  recurringCount: number;
  recurringDays: number[]; // 0-6 for Sunday-Saturday
  recurringDayNumbers: number[]; // For month_on_date or month_on_day
  endAt: Date | null;
  bookRecurring: boolean;

  // Resource settings (placeholder for now)
  noResources: boolean;
  serviceResourceRules: ServiceResourceRule[];
}

// Re-export from appointment types for consistency
export type { ServiceResourceRule } from 'src/models/appointment/_types';

export interface RecurringDay {
  id: number;
  name: string;
  shortName: string;
  selected: boolean;
}

export const DEFAULT_RECURRING_DAYS: RecurringDay[] = [
  { id: 0, name: 'Sunday', shortName: 'S', selected: false },
  { id: 1, name: 'Monday', shortName: 'M', selected: false },
  { id: 2, name: 'Tuesday', shortName: 'T', selected: false },
  { id: 3, name: 'Wednesday', shortName: 'W', selected: false },
  { id: 4, name: 'Thursday', shortName: 'Th', selected: false },
  { id: 5, name: 'Friday', shortName: 'F', selected: false },
  { id: 6, name: 'Saturday', shortName: 'Sa', selected: false },
];
